import type { ParticipantRestrictivePractice } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../../components/generic/Modal';
import { ParticipantRestrictivePracticeDeleteModal } from './ParticipantRestrictivePracticeDeleteModal';
import { ParticipantRestrictivePracticeEditModal } from './ParticipantRestrictivePracticeEditModal';

interface Props extends ChakraV3.ButtonProps {
  participantId: string;
  participantRestrictivePractice: ParticipantRestrictivePractice;
  isDisabled?: boolean;
}

export const ParticipantRestrictivePracticeActionMenu = (props: Props) => {
  const { participantId, participantRestrictivePractice, isDisabled, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button disabled={isDisabled} variant='plain' size='sm' {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantRestrictivePracticeEditModal, {
                participantId,
                participantRestrictivePractice,
              })
            }
            disabled={isDisabled}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantRestrictivePracticeDeleteModal, {
                participantId,
                restrictivePracticeId: participantRestrictivePractice.id,
                restrictivePracticeType: participantRestrictivePractice.type,
              })
            }
            color='danger'
            disabled={isDisabled}
            value='delete'
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
